import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Root = styled.div`
  width: 100vw;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;

  background: linear-gradient(270deg, #009688, #1565c0);
`;

const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  margin: 0 auto;
  max-width: 1646px;
  padding: 5px 32px;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

function Header({ children }) {
  return (
    <Root>
      <Wrapper>{children}</Wrapper>
    </Root>
  );
}

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

Header.defaultProps = {};

export default Header;
